var React = require('react');

var ContextContentMixin = require('./../context_content_mixin');
var CustomStylesMixin = require('./../custom_styles_mixin');
var RevealMixin = require('../reveal_mixin');

var createReactClass = require('create-react-class');
module.exports = createReactClass({

  mixins : [ContextContentMixin, CustomStylesMixin, RevealMixin],
  render : function () {
    return (
      <div>
        <div className="sign-container">
          <div className="nob" style={this.mergeStyles(this.borderColor(this.props.sign_frame_color), this.background_color(this.props.background_color))}></div>
          <div className="post left" style={this.background_color(this.props.sign_frame_color)}></div>
          <div className="post right" style={this.background_color(this.props.sign_frame_color)}></div>
          <div className="pane just-header" style={this.mergeStyles(this.borderColor(this.props.sign_frame_color), this.background_color(this.props.sign_background_color))}>
            <div className="headline" style={this.color(this.props.sign_text_color)}>
              Be Right Back
            </div>
          </div>
        </div>
        <div className="text-container">
          <div className="headline" style={this.secondary_text_color()}>
            Maintenance
          </div>
          <div className="context" style={this.primary_text_color()}>
            { this.contextContent() }
          </div>
          <div className="buttons-container">
            <a href={this.href(this.props.status_page_url)} style={this.mergeStyles(this.borderButton(), this.has_status_page())} target="_blank">
              <span className="fa fa-power-off"></span>
              View Statuspage
            </a>
          </div>
        </div>
      </div>
    )
  }
});



// WEBPACK FOOTER //
// ./app/assets/javascripts/components/better_error_pages/templates/sign/maintenance.jsx